// extracted by mini-css-extract-plugin
export default {"package-list-container":"OutboundAwb_package-list-container__95vZT","prefix-label":"OutboundAwb_prefix-label__jdUMH"};